<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('home.welcome') }}</h2>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Admin',
    components: {LayoutAuthenticated},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin',
                    disabled: true
                }
            ];
        }
    }
}
</script>
